export const validateMapping = (mapping: any, defaultValues: any, requiredFields: string[]): string[] => {
    const errors: string[] = [];
    const uniqueFields = new Set(requiredFields);

    uniqueFields.forEach((field) => {
      const mappingValue = mapping[field];
      const defaultValue = defaultValues[field];

      if (!mappingValue && !defaultValue) {
        let fieldName = field.substring(field.indexOf("_") + 1);
        fieldName = fieldName
          .replace(/_/g, " ")
          .replace(/([A-Z])/g, " $1")
          .trim();

        errors.push(
          `Field "${fieldName}" is required. Please map a field or set a default value.`
        );
      }
    });

    return errors;
  };

  export const scrollToErrorRow = (recordId: string, economicContacts: any[], rowsPerPage: number, page: number, setPage: (page: number) => void, tableRef: React.RefObject<HTMLDivElement>) => {
    // Find the index of the contact with the matching recordId
    const contactIndex = economicContacts.findIndex(
      (contact) => contact.index === parseInt(recordId)
    );
    if (contactIndex === -1) return;

    // Calculate which page the contact is on
    const newPage = Math.floor(contactIndex / rowsPerPage);

    // If the contact is not on the current page, change the page
    if (newPage !== page) {
      setPage(newPage);
    }

    // Wait for the page to update and then scroll to the row
    setTimeout(() => {
      const row = document.getElementById(`row-${recordId}`);
      if (row && tableRef.current) {
        row.scrollIntoView({ behavior: "smooth", block: "center" });
        // Highlight the row temporarily
        row.style.backgroundColor = "rgba(255, 0, 0, 0.3)";
        setTimeout(() => {
          row.style.backgroundColor = "";
        }, 2000);
      }
    }, 100); // Small delay to allow page update
  };